(function() {
  $(document).ready(function(){
    
    $(document).on("swell:setup", function() {
      $(".swell-referral-loader").hide();

      // show order summary on mobile
      if (window.location.href.indexOf("checkouts") > -1 && $("#swell-checkout").length > 0) {
        $(".order-summary-toggle").click();
      }
    
      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Redemption.initializeRedemptions(".swell-redemption-option-list");
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      SwellConfig.Referral.populateReferrals();
      $("#swell-post-checkout-popup").show();
      Swell.Redemption.initializeProductRedemptions(".swell-products-redemption-list", SwellConfig.Redemption.opts);
      SwellConfig.Redemption.initializeSlider('.desktop-redemption-slider', 4);
      SwellConfig.Redemption.initializeSlider('.mobile-redemption-slider', 2);
      
     // SwellConfig.Tier.initializeDummyTier();
      spapi.activeVipTiers = sortedVipTiers()
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
      SwellConfig.Tier.showCurrentTierColumnMobile();
    });

    $("body").on("click", ".account-nav__link-item.is-tab", function(){
      if($("#swellRewards").hasClass("active")) {
        $("#swell-account-part-2").show();
        $(".swell-products-redemption-list .right-arrow").click();
      } else {
        $("#swell-account-part-2").hide();
      }
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      $(".refer-customer-error").remove();
      var error_message = "";
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
        error_message = '<p class="refer-customer-error">Oops! Looks like this person has already made a purchase. Try referring another friend.</p>';
      } else if(textStatus && textStatus === "Please enter a valid email address"){
        error_message = '<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>';
      }

      $(".swell-referral-form-header-details").append(error_message);
      $("#swell-referral-refer-emails").addClass("error-border");
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function(){
        SwellConfig.Referral.populateReferrals();
      });
    });

    $('body').on('click', '#swell-post-checkout-backlink', function(){
      $('#swell-post-checkout-popup').hide();
    })

    if (window.location.href.indexOf("rewards") > -1) {
      $('body').addClass('template-reward-page');
    } else if (window.location.href.indexOf("refer") > -1) {
      $('body').addClass('template-refer-page');
    } else if (window.location.href.indexOf("account") > -1) {
      $('body').addClass('template-account-page');
    }

    $("body").on("click", ".tier-arrows .left-arrow", function(){
      if ($(".swell-tier-table").hasClass("bright")) {
        $(".swell-tier-table").removeClass("bright");
        $(".swell-tier-table").addClass("radiant");
      } else if ($(".swell-tier-table").hasClass("glowing")){
        $(".swell-tier-table").removeClass("glowing");
        $(".swell-tier-table").addClass("bright");
      } else if ($(".swell-tier-table").hasClass("radiant")) {
        $(".swell-tier-table").removeClass("radiant");
        $(".swell-tier-table").addClass("glowing");
      }
    })

    $("body").on("click", ".tier-arrows .right-arrow", function(){
      if ($(".swell-tier-table").hasClass("bright")) {
        $(".swell-tier-table").removeClass("bright");
        $(".swell-tier-table").addClass("glowing");
      } else if ($(".swell-tier-table").hasClass("glowing")){
        $(".swell-tier-table").removeClass("glowing");
        $(".swell-tier-table").addClass("radiant");
      } else if ($(".swell-tier-table").hasClass("radiant")) {
        $(".swell-tier-table").removeClass("radiant");
        $(".swell-tier-table").addClass("bright");
      }
    })

  });
}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class=\"swell-campaign\">\n  <div\n    class=\"swell-campaign-content\"\n    data-display-mode=\"modal\"\n   data-campaign-id=\"<%= campaign.id %>\">\n    <div class=\"swell-campaign-image\">\n      <img class=\"swell-campaign-image-content\" src=\"<%= campaign.background_image_url %>\" alt=\"<%= campaign.title %>\">\n    </div>\n    <div class=\"swell-campaign-icon\">\n      <span class=\"swell-campaign-icon-content\"><i class=\"fa <%= campaign.icon %>\"></i></span>\n    </div>\n    <div class=\"swell-campaign-value\">\n      <span class=\"swell-campaign-value-content\"><%= campaign.reward_text %></span>\n    </div>\n    <div class=\"swell-campaign-type\">\n      <span class=\"swell-campaign-type-content\"><%= campaign.title %></span>\n    </div>\n  </div>\n</li>"
      }
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Redemption = {
    opts: {
      templates: {
        redemptionOptionProduct: "<li class='swell-redemption-option'> <div class='swell-redemption-option-holder'> <div class='image-holder swell-redemption-option-content' data-confirm-title='Yes go for it.' data-confirm-content='You currently have *|point_balance|* points. This costs *|amount|*. ' data-success-title='Success.' data-success-content='This was successfully added to your cart.' data-success-cart-btn='View Cart' data-error-title='So close.' data-error-content='This requires *|amount|* points and you only have *|point_balance|*. Earn more to be able to add this to your cart.' data-variant-id='<%= redemption.applies_to_id %>'  data-redemption-option-id='<%= redemption.id %>' > <img src='<%= redemption.background_image_url %>'> </div> <div class='swell-redemption-option-value'> <%= redemption.name %> </div> <div class='swell-redemption-option-cost'> <%= redemption.cost_text %> </div> </div> </li>"
      }
    },
    initializeRedemptions: function(containerSelector){
      if($(containerSelector).length == 0) {
        return;
      }

      var redemptions = spapi.activeRedemptionOptions;

      redemptions.forEach(function(redemption) {
        if (redemption.discount_type == "fixed_amount") {
          template = '<li class=\"swell-redemption-option\"><div class=\"swell-redemption-option-content\" data-redemption-option-id=\"' + redemption.id + '"><div class=\"swell-redemption-option-value\">' + redemption.name + '</div> <div class="isequal"> = </div> <div class=\"swell-redemption-option-cost\">' + redemption.cost_text + '</div></div></li>';
          $(containerSelector).append(template);
        }
      });

      swellAPI.refreshEmbeds();
    },
    initializeSlider: function(containerSelector, slides) {
      $(containerSelector).slick({
        slidesToShow: slides,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        nextArrow: '<i class="swell-icon-cheveron-right slick-arrow-right right-arrow"></i>',
        prevArrow: '<i class="swell-icon-cheveron-left slick-arrow-left left-arrow"></i>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralRegisterHeading: "<span class='refer-heading'>Refer a Friend</span>Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Enter your email",
        referralRegisterFormSubmit: "",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "<span class='refer-heading'>Refer a Friend</span>Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralReferFormDetails: "Now, enter your friends’ emails.",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareTwitter: "Share",
        referralShareCopy: "Copy Link",

        referralFacebookIcon: "swell-icon-Facebook",
        referralLinkIcon: "swell-icon-link",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy the link above and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"> <%= localization.referralRegisterDetails %> </p> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralRegisterFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> <input class="swell-referral-form-list-submit" type="submit" value="NEXT" name="swell-referral-register-submit" id="swell-referral-register-submit"> </li> </ul> </div> </form> </div> <a href="https://www.strivectin.com/innercircle-faq" class="learn-more">Learn More</a> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"> <%= localization.referralReferDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralReferFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-refer-emails" id="swell-referral-refer-emails" swellrequired="swellrequired" placeholder="<%= localization.referralReferFormEmails %>"> <input class="swell-referral-form-list-submit" value="SEND" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"> <%= localization.referralReferMediaDetails %> </p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-message" aria-hidden="true"></i>&nbsp;SMS </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-messenger" aria-hidden="true"></i>&nbsp;Message</div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareCopy %> </div> </li> </ul> </div> <a href="https://www.strivectin.com/innercircle-faq" class="learn-more">Learn More</a> </div>'
      }
    },
    populateReferrals: function(){
      if (spapi.authenticated) {
        var tbody = ".swell-referral-activity";
        $(tbody).html("");

        var referral_receipts = spapi.customer.referral_receipts;
        referral_receipts.forEach(function(referral_receipt){
          var referral_status = "Invited";
          if(referral_receipt.completed_at) {
            referral_status = "Purchased (" + spapi.activeReferralCampaign.reward_text + " earned)";
          }
          $(tbody).append("<tr> <td>" + referral_receipt.email + "</td> <td>" + referral_status + "</td> </tr>");
        });
      }
    }
  };

}).call(this);

(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    showCurrentTierColumnMobile: function(){
      if (spapi.authenticated) {
        var customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
        var current_tier = "bright";
        if (customer_tier_rank == 1) {
          current_tier = "glowing";
        } else if (customer_tier_rank == 2) {
          current_tier = "radiant";
        }

        $(".swell-tier-table").addClass(current_tier);
      } else {
        $(".swell-tier-table").addClass("bright");
      }
    },
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      spapi.activeVipTiers.forEach(function(tier){
        $(".swell-tier-status-row").append("<th data-tier-id='" + tier.id + "'></th>");
      });
      $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
      $(".swell-tier-status-row th[data-tier-id=\"" + customer_tier_id + "\"]").append("Current Status");
      columnLength = $(".swell-tier-table tbody tr:eq(0)").children().length;
      $tierStatusRow = $(".swell-tier-status-row");
      $tierValueRow = $(".swell-tier-values");      
      
      if (customer_tier_id === spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
        encouragement = "You are in the top tier";
        $(".swell-tier-status-msg").text(encouragement);
      } else {
        var spend_required = ((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100);
        $(".swell-spend-required").text("$" + spend_required);
        $(".swell-tier-status-row th[data-tier-id=\"" + next_tier.id + "\"]").append("Spend $" + spend_required + " more to earn " + next_tier.name);
      }
    },
    /*initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Bright",
        points: "Free",
        welcome_points: "<i class=\"circle\" aria-hidden=\"true\"></i>",
        points_for_purchase: "<i class=\"circle\" aria-hidden=\"true\"></i>",
        first_purchase_bonus: "<i class=\"circle\" aria-hidden=\"true\"></i>",
        early_access: "<i class=\"circle\" aria-hidden=\"true\"></i>",
        special_promotions: "<i class=\"circle\" aria-hidden=\"true\"></i>",
        birthday_gift: "<i class=\"circle\" aria-hidden=\"true\"></i>",
        welcome_tier: "",
        free_shipping: "",
        swellrequiredAmountSpent: "$0",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },*/
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].points = spapi.activeVipTiers[0].prettyAmountSpent + " Spend Per Year";
      spapi.activeVipTiers[0].welcome_points = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[0].points_for_purchase = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[0].first_purchase_bonus = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[0].early_access = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[0].special_promotions = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[0].birthday_gift = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[0].welcome_tier = "";
      spapi.activeVipTiers[0].free_shipping = "";
      
      spapi.activeVipTiers[1].points = spapi.activeVipTiers[1].prettyAmountSpent + " Spend Per Year";
      spapi.activeVipTiers[1].welcome_points = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].points_for_purchase = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].first_purchase_bonus = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].early_access = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].special_promotions = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].birthday_gift = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[1].welcome_tier = "250 Points";
      spapi.activeVipTiers[1].free_shipping = "";

      spapi.activeVipTiers[2].points = spapi.activeVipTiers[2].prettyAmountSpent + " Spend Per Year";
      spapi.activeVipTiers[2].welcome_points = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].points_for_purchase = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].first_purchase_bonus = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].early_access = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].special_promotions = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].birthday_gift = "<i class=\"circle\" aria-hidden=\"true\"></i>";
      spapi.activeVipTiers[2].welcome_tier = "500 Points";
      spapi.activeVipTiers[2].free_shipping = "<i class=\"circle\" aria-hidden=\"true\"></i>";
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          name: {
            className: "swell-tier-names",
            title: "Benefits"
          },
          points: {
            className: "swell-tier-values",
            title: ""
          }
        },
        body: {
          welcome_points: {
            title: "Welcome Points"
          },
          points_for_purchase: {
            title: "Points for Purchase"
          },
          first_purchase_bonus: {
            title: "First Purchase Bonus"
          },
          early_access: {
            title: "Early Access"
          },
          special_promotions: {
            title: "Special Promotions"
          },
          birthday_gift: {
            title: "Birthday Gift"
          },
          welcome_tier: {
            title: "Welcome to The Tier"
          },
          free_shipping: {
            title: "Free Expedited Shipping"
          }
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\">" + tier[key] + "</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\">" + tier[key] + "</td>");
        });
        i++;
      }
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };

}).call(this);

function sortedVipTiers() {
	var tiers = spapi.activeVipTiers;
    var sortedTiers = [];
  	for (i = 0; i < tiers.length; i++) {
      var rank = tiers[i].rank;
      sortedTiers[rank] = tiers[i];
    } 
  return sortedTiers;
}

